import { getAccountsQueryConfig } from '@api/lendingAPI/queryConfigs';
import { fetchGetSplitTest } from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';
import { repeatsTopUpEligibilitySplitTestName } from '../../NewOutstandingView/NewOutstandingView.helpers';

export const useGetNotYetTopUpEligibleData = (accountId: string) => {
    const stateKey = useStateKey();

    const { data: branch } = useQuery({
        queryKey: [
            'fetchGetSplitTest',
            stateKey,
            repeatsTopUpEligibilitySplitTestName
        ],
        queryFn: () =>
            fetchGetSplitTest({
                stateKey,
                experimentName: repeatsTopUpEligibilitySplitTestName
            }),
        select: ({ data }) => data.branch,
        suspense: true
    });

    const { data: amountToRepayBeforeTopUp } = useQuery({
        ...getAccountsQueryConfig(stateKey),
        select: ({ data }) => {
            const account = data.accounts.find(
                (account) => account.account_id === accountId
            );
            return account!.topup_eligibility!.amount_to_repay_before_topup;
        },
        suspense: true
    });

    return {
        inFirstRepaymentTest: branch === 'INCLUDE',
        amountToRepayBeforeTopUp: amountToRepayBeforeTopUp!
    };
};
